import { useState, useEffect } from 'react';

const useWindowFocused = (): boolean => {

    const [isFocused, setIsFocused] = useState(true); // Assume window is initially focused

    useEffect(() => {
        const handleFocus = () => {
            setIsFocused(true);
        };

        const handleBlur = () => {
            setIsFocused(false);
        };

        // Add event listeners
        window.addEventListener('focus', handleFocus);
        window.addEventListener('blur', handleBlur);

        // Cleanup function to remove event listeners
        return () => {
            window.removeEventListener('focus', handleFocus);
            window.removeEventListener('blur', handleBlur);
        };
    }, []); // Empty dependency array ensures this effect runs only once

    return isFocused;
}

export default useWindowFocused;
